// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.redMap {
  background-color: lightcoral;
}
.orangeMap{
  background-color: lightsalmon;
}
.greenMap{
  background-color: lightgreen;
}
.workingMap{
  background-color: lightgray;
}

.tableNoBorder {
  border-bottom-style: hidden;
}

.padTop {
 padding-top: 10px;
}

.padLeft {
  padding-left: 10px;
 }

.cardTitleP {
  padding-left: 20px;
}

button {
  outline: none !important;
}
.paddingButton {
  padding-left: 40px;
}

.settingsInputSize {
  width: 10%;
}

.form-control{
  box-shadow: none;
}

.btn{
  box-shadow: none;
}

.onHover:hover{
  background-color: white;
}

.myBtn{
  width: 8em;
}
.modal-content {
  /* 80% of window height */
  height: 80%;
}
.heightOverflow{
  height: 60px;
}

.tableFont{
  font-size: 10px;
}
/* v primeru, da gledamo preko tablice pa do telefon */
@media (max-width: 991.98px) {
  .body {
    font-size: 8px;
  }

  .mobileHide {
    visibility: hidden;
    display: none;
  }

  .mobile{
    margin: 0;
    padding-right: 0;
    padding-left: 0;

    padding-top: 0%;
    padding-bottom: 0%;
  }
  .mobileLeft {
    padding-top: 0%;
    padding-bottom: 0%;
  }

  .mobileRight {
    float: right;
    padding-top: 0%;
    padding-bottom: 0%;
  }


  .tbodyBorder {
    border-bottom-style: hidden;
  }

  .mobileTdShort {
    padding-left: 0%;
    width: 40px;
  }

  .mobileTdShortest {
    width: 50px;
  }
  .mobileTdLong {
    padding-left: 0%;
    width: 200px;
  }
}

@media (max-width: 431.98px) {


  .mobilePadding {
    padding-top: 10px;
  }
}

table {
  table-layout: fixed;
  width: 100%;
}


/*td {
  border: 1px solid #000;
  width: 150px;
}*/

#overlay {
  background: #ffffff;
  color: #666666;
  position: fixed;
  height: 100%;
  width: 100%;
  z-index: 5000;
  top: 0;
  left: 0;
  float: left;
  text-align: center;
  padding-top: 25%;
  opacity: .80;
}

#overlayNoWhite {
  position: fixed;
  height: 100%;
  width: 100%;
  z-index: 5000;
  top: 0;
  left: 0;
  float: left;
  text-align: center;
  padding-top: 35%;
  opacity: .80;
}

@media (min-width: 450px){
  .tableDesktop {
    width:25%;
  }

  .tableDesktopShort {
    width: 50px;
  }
  .card-columns {
    -moz-column-count: 4;
         column-count: 4;
  }

}

@media (max-width: 450px){
  .card-columns {
    -moz-column-count: 2;
         column-count: 2;
  }
}


`, "",{"version":3,"sources":["webpack://./src/app/monitor/setting-bar/setting-bar.component.css"],"names":[],"mappings":"AAAA;EACE,4BAA4B;AAC9B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;CACC,iBAAiB;AAClB;;AAEA;EACE,kBAAkB;CACnB;;AAED;EACE,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;AAC1B;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,UAAU;AACZ;AACA;EACE,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;AACA,sDAAsD;AACtD;EACE;IACE,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,aAAa;EACf;;EAEA;IACE,SAAS;IACT,gBAAgB;IAChB,eAAe;;IAEf,eAAe;IACf,kBAAkB;EACpB;EACA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,eAAe;IACf,kBAAkB;EACpB;;;EAGA;IACE,2BAA2B;EAC7B;;EAEA;IACE,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,WAAW;EACb;EACA;IACE,gBAAgB;IAChB,YAAY;EACd;AACF;;AAEA;;;EAGE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;;AAGA;;;EAGE;;AAEF;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,YAAY;EACZ,WAAW;EACX,aAAa;EACb,MAAM;EACN,OAAO;EACP,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,aAAa;EACb,MAAM;EACN,OAAO;EACP,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE;IACE,SAAS;EACX;;EAEA;IACE,WAAW;EACb;EACA;IACE,oBAAe;SAAf,eAAe;EACjB;;AAEF;;AAEA;EACE;IACE,oBAAe;SAAf,eAAe;EACjB;AACF","sourcesContent":[".redMap {\n  background-color: lightcoral;\n}\n.orangeMap{\n  background-color: lightsalmon;\n}\n.greenMap{\n  background-color: lightgreen;\n}\n.workingMap{\n  background-color: lightgray;\n}\n\n.tableNoBorder {\n  border-bottom-style: hidden;\n}\n\n.padTop {\n padding-top: 10px;\n}\n\n.padLeft {\n  padding-left: 10px;\n }\n\n.cardTitleP {\n  padding-left: 20px;\n}\n\nbutton {\n  outline: none !important;\n}\n.paddingButton {\n  padding-left: 40px;\n}\n\n.settingsInputSize {\n  width: 10%;\n}\n\n.form-control{\n  box-shadow: none;\n}\n\n.btn{\n  box-shadow: none;\n}\n\n.onHover:hover{\n  background-color: white;\n}\n\n.myBtn{\n  width: 8em;\n}\n.modal-content {\n  /* 80% of window height */\n  height: 80%;\n}\n.heightOverflow{\n  height: 60px;\n}\n\n.tableFont{\n  font-size: 10px;\n}\n/* v primeru, da gledamo preko tablice pa do telefon */\n@media (max-width: 991.98px) {\n  .body {\n    font-size: 8px;\n  }\n\n  .mobileHide {\n    visibility: hidden;\n    display: none;\n  }\n\n  .mobile{\n    margin: 0;\n    padding-right: 0;\n    padding-left: 0;\n\n    padding-top: 0%;\n    padding-bottom: 0%;\n  }\n  .mobileLeft {\n    padding-top: 0%;\n    padding-bottom: 0%;\n  }\n\n  .mobileRight {\n    float: right;\n    padding-top: 0%;\n    padding-bottom: 0%;\n  }\n\n\n  .tbodyBorder {\n    border-bottom-style: hidden;\n  }\n\n  .mobileTdShort {\n    padding-left: 0%;\n    width: 40px;\n  }\n\n  .mobileTdShortest {\n    width: 50px;\n  }\n  .mobileTdLong {\n    padding-left: 0%;\n    width: 200px;\n  }\n}\n\n@media (max-width: 431.98px) {\n\n\n  .mobilePadding {\n    padding-top: 10px;\n  }\n}\n\ntable {\n  table-layout: fixed;\n  width: 100%;\n}\n\n\n/*td {\n  border: 1px solid #000;\n  width: 150px;\n}*/\n\n#overlay {\n  background: #ffffff;\n  color: #666666;\n  position: fixed;\n  height: 100%;\n  width: 100%;\n  z-index: 5000;\n  top: 0;\n  left: 0;\n  float: left;\n  text-align: center;\n  padding-top: 25%;\n  opacity: .80;\n}\n\n#overlayNoWhite {\n  position: fixed;\n  height: 100%;\n  width: 100%;\n  z-index: 5000;\n  top: 0;\n  left: 0;\n  float: left;\n  text-align: center;\n  padding-top: 35%;\n  opacity: .80;\n}\n\n@media (min-width: 450px){\n  .tableDesktop {\n    width:25%;\n  }\n\n  .tableDesktopShort {\n    width: 50px;\n  }\n  .card-columns {\n    column-count: 4;\n  }\n\n}\n\n@media (max-width: 450px){\n  .card-columns {\n    column-count: 2;\n  }\n}\n\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
